<template>
<div>
	<div style="min-height: 720px;padding: 20px 20px 20px 0;">
		<el-form
			:model="formData"
			ref="formData"
			class="backgroundForm"
			label-width="200px"
			v-loading="loading"
		>
			<el-form-item label="等级说明页：" required>
				<div></div>
				<el-upload
					ref="upload1"
					action="#"
					list-type="picture-card"
					:on-change="(file, fileList) => {handleChange(file, fileList, 'levelDetailUrl')}"
					:on-remove="(file, fileList) => {handleRemove(file, fileList, 'levelDetailUrl')}"
					:http-request="httpRequest"
					:file-list="fileList"
					:limit="1"
					:before-upload="beforeUpload"
					:class="fileList.length == 1?'hide_box':''"
				>
					<i class="el-icon-plus"></i>
				</el-upload>
				<span style="color: red; font-size: 14px">建议尺寸：303 px*360px，图片大小不能超过300kb，类型：JPG、PNG</span>
			</el-form-item>

			<el-form-item label="会员章程页：" required>
				<div></div>
				<el-upload
					ref="upload2"
					action="#"
					list-type="picture-card"
					:on-change="(file, fileList) => {handleChange(file, fileList, 'membershipCharterUrl')}"
					:on-remove="(file, fileList) => {handleRemove(file, fileList, 'membershipCharterUrl')}"
					:http-request="httpRequest"
					:file-list="fileList2"
					:limit="1"
					:before-upload="beforeUpload"
					:class="fileList2.length == 1?'hide_box':''"
				>
					<i class="el-icon-plus"></i>
				</el-upload>
				<span style="color: red; font-size: 14px">建议尺寸：303 px*360px，图片大小不能超过3MB，类型：JPG、PNG</span>
			</el-form-item>

			<el-form-item label=" 权益分类：" >
				<el-table
				:header-cell-style="{
					'text-align': 'center',
					'border-bottom': '2px solid #EBEEF5',
					background: '#FAFAFA',
				}"
				:cell-style="{ 'text-align': 'center', overflow: 'visible' }"
				:data="formData.benefitCategoryList"
				border
				style="width:1400px;overflow: visible;"
				>
				<el-table-column prop="date" label="分类排序" width="110">
					<template slot-scope="scope">
						<span>{{ scope.$index + 1 }}</span>
						<el-tooltip class="item" effect="light" content="默认分类，不可删除" placement="top" v-if="scope.$index == 0">
							<el-button type="text" style="width: 35px;">
								<i class="el-icon-question" style="color:#ccc" ></i>
							</el-button>
						</el-tooltip>
						<i class="el-icon-question" style="opacity: 0;width: 35px;"  v-else></i>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="分类名称">
					<template slot-scope="scope">
						<el-input v-model="scope.row.name" style="margin: 0 20px; width: 150px" :disabled="!scope.row.isEdit"></el-input>
						<span @click="editName(scope.$index)" style="cursor: pointer;color: #7B61FF;" v-if="!scope.row.isEdit">修改</span>
						<span @click="saveName(scope.$index)" style="cursor: pointer;color: #7B61FF;" v-else>保存</span>
					</template>
				</el-table-column>
				<el-table-column prop="num"  label="分类权益">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="light" :content="scope.row.categoryListStr" placement="top">
							<el-button type="text" style="width: 35px;">
								<span style="text-decoration: underline">{{ scope.row.num }}</span>
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column width="100" label="操作">
						<template  slot-scope="scope">
							<span style="cursor: pointer;color: #999999;" v-if="scope.$index == 0 || scope.row.num > 0">删除</span>
							<span @click="itemDelPrize(scope.$index)" style="cursor: pointer;color: #7B61FF;" v-else>删除</span>
							<span @click="itemAddPrize(scope.$index)" style="cursor: pointer;color: #7B61FF;margin-left: 20px;" v-if="scope.$index == formData.benefitCategoryList.length -1">添加</span>
						</template>
				</el-table-column>
				</el-table>
			</el-form-item>

		</el-form>
		<div class="create_bottom" >
      <el-button
        class="keepBtn"
        size="medium"
				style="width: 72px;"
        @click="save()"
        >确定</el-button>
		</div>
	</div>
</div>
</template>

<script>
import { getGlobalConfig,postGlobalConfig,uploadpic } from "@/api/brandCustom/brandMemberCenter";
export default {
name: '' ,
components: {},
props:{},
data() {
return {
	loading:false,
	fileList:[],//等级说明页
	fileList2:[],//会员章程页
	formData:{
		levelDetailUrl:'',
		membershipCharterUrl:'',
		benefitCategoryList:[
			{
				name:'',
				num:0,
				categoryListStr:'',
				isEdit:false,
			},
			{
				name:'',
				num:0,
				categoryListStr:'',
				isEdit:false,
			}
		],
	},
}
},
computed: {},
created() {

},
mounted() {
	this.getConfig()
},
methods: {
	  //获取详情
		getConfig(){
				this.loading = true,
				getGlobalConfig().then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.formData = res.data;
						this.fileList = [
							{
								url:  this.formData.levelDetailUrl,
								name: "等级说明页",
							},
						];
						this.fileList2 = [
							{
								url:  this.formData.membershipCharterUrl,
								name: "会员章程页",
							},
						];
						this.formData.benefitCategoryList = res.data.benefitCategoryList.map((item) => {
							return { ...item, isEdit: false };
						});
					}else{
						this.$message.error(res.message);
					}
				});
		},
		//保存页面
		save(){
			if(!this.formData.levelDetailUrl){
				this.$message.warning("等级说明页不能为空哦！");
        return;
			}
			if(!this.formData.membershipCharterUrl){
				this.$message.warning("会员章程页不能为空哦！");
        return;
			}
			// 请将权益分类名称填写完整！
			let isFlay = false;
			this.formData.benefitCategoryList.forEach((item) => {
				if (!item.name ) {
					isFlay = true;
				}
			});
      if (isFlay) {
        return this.$message.warning("请将权益分类名称填写完整！");
      }

			postGlobalConfig(this.formData).then((res) => {
				if(res.code == 1){
					this.$message.success("保存成功");
					this.getConfig()
				}else{
					this.$message.error(res.message);
				}
			})
			
		},
		//上传图片
		handleChange(file, fileList,item) {
			const isLt3M = file.size < 1024 * 1024 * 3;
			if (!isLt3M) {
				this.$message.error("文件大小不符合要求，请重新上传");
				if(item == 'levelDetailUrl'){
					this.$refs.upload1.clearFiles();
					return
				}else{
					this.$refs.upload2.clearFiles();
					return
				}


			} else {
				if(item == 'levelDetailUrl'){
					this.fileList = fileList;
					this.$refs.upload1.$children[1].$el.style.display = "none";
				}else{
					this.fileList2 = fileList;
					this.$refs.upload2.$children[1].$el.style.display = "none";
				}

				// this.objectForm.name = file.name;
				let formdata = new FormData();
				formdata.append("file", file.raw);
				let type = 2 
				if(item == 'levelDetailUrl'){
					type = 2 
				}else{
					type = 3
				}

				uploadpic(formdata,type).then((res) => {
					if(res.code == 1){
						// 获取图片真实url
						if(item == 'levelDetailUrl'){
							this.formData.levelDetailUrl = res.data.fileUrl;
						}else{
							this.formData.membershipCharterUrl = res.data.fileUrl;
						}
					}else{
						this.$message.error(res.message);
						if(item == 'levelDetailUrl'){
							this.fileList = [];
							this.formData.levelDetailUrl = "";
							this.$refs.upload1.$children[1].$el.style.display = "inline-block";
						}else{
							this.fileList2 = [];
							this.formData.membershipCharterUrl = "";
							this.$refs.upload2.$children[1].$el.style.display = "inline-block";
						}
					}
				});
				
			}
		},
		handleRemove(file, fileList,item) {
			if(item == 'levelDetailUrl'){
				this.formData.levelDetailUrl = "";
				this.$refs.upload1.$children[1].$el.style.display = "inline-block";
			}else{
				this.formData.membershipCharterUrl = "";
				this.$refs.upload2.$children[1].$el.style.display = "inline-block";
			}
		},  
		beforeUpload(file) {
			let fileType
			if (this.limitType) {
				const typeArry = [".jpg", ".png", ".JPG", ".PNG"];
				const type = file.name.substring(file.name.lastIndexOf("."));
				const isImage = typeArry.indexOf(type) > -1;
				if (!isImage) {
					fileType = false;
					this.$message({
						message: "图片格式不符合要求，请重新上传！",
						type: "warning",
					});
				}
			} else {
				fileType = true;
			}
			return fileType;
		},
		httpRequest() {},
		//删除权益
		itemDelPrize(index) {
			if (this.formData.benefitCategoryList.length == 1) {
				this.$message.warning("默认分类，不可删除");
				return;
			}
			this.formData.benefitCategoryList.splice(index, 1);
		},
		//增加权益
		itemAddPrize(){
			this.formData.benefitCategoryList.push({
				name:'',
				num:0,
				categoryListStr:'',
				sort:this.formData.benefitCategoryList.length+1,
				category:1,
				isEdit:false,
			});
		},
		// 修改名称
		editName(index){
			this.formData.benefitCategoryList[index].isEdit = true;
		},
		//保存名称
		saveName(index){
			this.formData.benefitCategoryList[index].isEdit = false;
		}
	}
}
</script>
<style lang='scss' scoped>
/deep/.hide_box .el-upload--picture-card{
    display: none;
}
</style>